import { CheckCircle, XCircle, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAdmin } from './AdminContext';
import { StatusBadge } from './AdminShared';

export const AdminFeaturesTab = () => {
  const { featureRequests, apiCall } = useAdmin();

  return (
    <>
      <h2 className="text-xl font-semibold mb-4">Feature Requests ({featureRequests.length})</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {featureRequests.map(request => (
          <Card key={request.id} className="bg-card border-border">
            <CardHeader className="pb-2">
              <div className="flex items-center justify-between">
                <CardTitle className="text-lg">{request.business_name}</CardTitle>
                <StatusBadge status={request.status} />
              </div>
              <CardDescription>{request.category} - {request.email}</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground mb-2 line-clamp-2">{request.why_feature}</p>
              {request.status === 'pending' && (
                <div className="flex gap-2">
                  <Button size="sm" variant="outline" className="flex-1" onClick={() => apiCall('put', `/feature-requests/${request.id}?status=approved`)}><CheckCircle size={14} className="mr-1" /> Approve</Button>
                  <Button size="sm" variant="destructive" className="flex-1" onClick={() => apiCall('put', `/feature-requests/${request.id}?status=rejected`)}><XCircle size={14} className="mr-1" /> Reject</Button>
                </div>
              )}
              <Button size="sm" variant="ghost" className="w-full text-destructive hover:text-destructive text-xs mt-2" onClick={() => apiCall('delete', `/feature-requests/${request.id}`)}><Trash2 size={12} className="mr-1" /> Delete</Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
};
